<template>
  <!-- PREHLED ZARIZENI NA DETAILU ROUTOVACICH SKUPIN -->
  <div class="list-page custom-table--detail">
    <div class="layout__content__header list-page__header p-0">
      <CopyNotification
        :opened="copyConfirmVisible"
        :text="'zkopirovanoDoSchranky'"
        @close="copyConfirmVisible = false"
      />
      <div v-if="project" class="d-flex justify-content-between">
        <div class="d-flex list-page__left align-items-center">
          <div
            v-if="project.projectId"
            class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
          >
            <!--div v-if="suggested != ''" class="custom-control--search__suggested"><span class="atom-tag" @click="suggested = ''">{{suggested}}</span></div-->
            <input
              id="guisearch"
              ref="searchInput"
              v-model="search"
              :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
              autofocus
              class="w-100"
              type="text"
              @keyup.enter="searchLoraDevices()"
            />
            <div v-if="search" class="atom-icon" @click="clearSearch()">
              <img src="@/assets/icons/actions/ico-close.svg" />
            </div>
            <div class="atom-icon" @click="searchLoraDevices()">
              <img src="@/assets/icons/actions/ico-search-black.svg" />
            </div>
            <div class="custom-control--search__suggestions">
              <div
                v-for="(suggestion, index) in suggestionsArray"
                :key="index"
                class="custom-control--search__suggestions__item"
                @click="setSuggestion(suggestion)"
              >
                <span>{{ suggestion }}</span>
              </div>
            </div>
          </div>
          <!--div class="list-page__link">
            <a class="d-flex align-items-center">
              {{ $t("pokrocilaFiltrace") }}
              <img src="@/assets/icons/arrows/arr-orange-down.svg" class="" />
            </a>
          </div-->
        </div>
      </div>
    </div>
    <div class="layout__content__content pt-5 px-0">
      <div v-if="selectable" v-click-outside="closeDropdownActions" class="dropdown-actions">
        <button v-if="selectedRows.length > 0" class="btn btn-primary" @click="showDropdownActions()">
          <div class="d-flex align-items-center">
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </div>
        </button>
        <button v-else class="btn btn-primary" disabled>
          <div class="d-flex align-items-center">
            {{ $t("hromadneAkce") }}
            <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
          </div>
        </button>
        <div
          v-if="isActionsDropdownVisible && selectedRows.length > 0"
          class="dropdown-actions__wrapper dropdown-actions__wrapper--wide"
        >
          <div class="dropdown-actions__inner">
            <div class="row">
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleAddTagsModal('editTags')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-label.svg" />
                </div>
                {{ $t("pridatTagy") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleChangeStatusModal('changeStatus')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenarezimu.svg" />
                </div>
                {{ $t("zmenitRezim") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleRemoveTagsModal('editTags')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-label.svg" />
                </div>
                {{ $t("odebratTagy") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleSendMessageModal('sendMessage')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zprava.svg" />
                </div>
                {{ $t("odeslatZpravu") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center col-6"
                @click="
                  () => {
                    actionItems = selectedRows
                    toggleAddToGroupsModal('addToGroups')
                  }
                "
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                </div>
                {{ $t("CHANGE_DATA_FLOW") }}
              </div>
              <div
                class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-sm-6 col-12"
                @click="exportDevices('xlsx')"
              >
                <div class="atom-icon">
                  <img src="@/assets/icons/icon_xlsx.svg" />
                </div>
                {{ $t("LABEL_EXPORT_XLSX") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectable" class="d-flex align-items-center justify-content-end mb-4">
        <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
        <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
          {{ $t("OdvybratVse") }}
        </span>
      </div>

      <div v-if="allDevices.length > 0">
        <div class="position-relative w-100">
          <div id="lora" class="table-responsive">
            <table class="table table-main table-hover">
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ 'min-width': column.minWidth }"
                  >
                    <span v-if="column.sortable != true">
                      {{ $t(column.name) }}
                    </span>
                    <span v-else>
                      <div class="title" @click="sortItemsBy(column.sortBy)">
                        {{ $t(column.name) }}
                      </div>
                      <div v-if="sortBy == column.sortBy" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td
                    v-for="(column, column_index) in columns"
                    :key="column_index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ width: column.minWidth }"
                  >
                    <span v-if="column.name == 'custDeviceName'">
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceId === item.deviceId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: 'device',
                          params: {
                            id: item.deviceId.includes(':') ? item.deviceId.split(':')[1] : item.deviceId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span
                          :style="{
                            maxWidth: column.minWidth,
                            minWidth: column.minWidth
                          }"
                          style="display: block; word-wrap: break-word"
                        >
                          {{ item[column.type] }}
                        </span>
                      </RouterLink>
                    </span>
                    <span v-else-if="column.type == 'deviceId'">
                      <div v-tooltip :title="item.deviceId">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(item.deviceId, 6) }}
                        </span>
                        <span class="eui-full">{{ item.deviceId }}</span>
                      </div>
                      <div class="ml-2 copy d-flex align-items-center" @click="copyToClipboard(item.deviceId)">
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                    <div v-else-if="column.type == 'deviceGroups'">
                      <div
                        v-for="group in item.deviceGroups.slice(0, 1)"
                        :key="group.deviceGroupId + 'g' + item.deviceId"
                        class="d-flex"
                      >
                        <a
                          class="link-gray"
                          @click="
                            $router.push({
                              name: 'group',
                              params: {
                                id: group.deviceGroupId,
                                group: group
                              }
                            })
                          "
                        >
                          <span>
                            {{ $filters.strLimit(group.deviceGroupName, 25) }}
                          </span>
                        </a>
                        <div v-if="item.deviceGroups.length > 1" class="atom-expand" @click="toggleGroup(item)">
                          <span v-if="openedGroups.indexOf(item) > -1">-</span>
                          <span v-else>+</span>
                          {{ item.deviceGroups.length - 1 }}
                        </div>
                      </div>

                      <div v-if="openedGroups.indexOf(item) > -1" class="atom-expand__content d-flex flex-wrap">
                        <div
                          v-for="group in item.deviceGroups.slice(1, item.deviceGroups.length)"
                          :key="group.deviceGroupId + 'g' + item.device"
                          class=""
                        >
                          <a
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  ...$router.currentRoute.value.params,
                                  id: group.deviceGroupId,
                                  group: group
                                }
                              })
                            "
                          >
                            <span>{{ group.deviceGroupName }}</span>
                          </a>
                        </div>
                      </div>

                      <div class="" />
                    </div>
                    <span v-else-if="column.type == 'status'">
                      <div
                        v-if="item.suspended == false && item.enabled == true"
                        class="atom-circle atom-circle--success"
                      >
                        <div v-tooltip :title="$t('activeZarizeniCerpaSluzbu')">A</div>
                      </div>
                      <div
                        v-else-if="item.suspended == true && item.enabled == true"
                        class="atom-circle atom-circle--danger"
                      >
                        <div v-tooltip :title="$t('overLimitZarizeniPrekrociloLimit')">0</div>
                      </div>
                      <div v-else-if="item.enabled == false" class="atom-circle atom-circle--gray">
                        <div v-tooltip :title="$t('standByZarizeniJeNeaktivni')">S</div>
                      </div>
                    </span>
                    <div v-else-if="column.type == 'tags'">
                      <TagBubbles :is-open="openedTags.includes(item)" :tag-list="item.tags" />
                    </div>

                    <span v-else-if="column.type == 'bateryStatus'">
                      <BatteryStatus :device="item" />
                    </span>

                    <span v-else-if="column.type == 'signalStrength'">
                      <SignalStrengthIcon :device="item" />
                    </span>

                    <span v-else-if="column.type == 'deviceType'">
                      {{ item.deviceProtocol }}
                    </span>

                    <span v-else-if="column.type == 'lastMessageIn'">
                      <span
                        v-if="item.lastMessageIn != null"
                        class="link"
                        @click="
                          () => {
                            toggleShowMessage('showMessage')
                            setMessageDeviceToShow(item)
                          }
                        "
                      >
                        {{ $t("pred") }}
                        {{ $filters.beforeTime(item.lastMessageIn, "short") }}
                      </span>
                    </span>

                    <span v-else-if="column.type == 'topicIn'">
                      <div v-tooltip :title="getTopicIn(item.deviceId)">
                        <span class="eui-short">
                          {{ $filters.strLimitEnd(getTopicIn(item.deviceId), 6) }}
                        </span>
                        <span class="eui-full">
                          {{ getTopicIn(item.deviceId) }}
                        </span>
                      </div>
                      <div
                        class="ml-2 copy d-flex align-items-center"
                        @click="copyToClipboard(getTopicIn(item.deviceId))"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>

                    <span v-else>
                      {{ item[column.type] }}
                    </span>
                  </td>
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == item.deviceId
                      }"
                      class="kebab"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
              <thead>
                <tr>
                  <th>
                    <span v-if="columns[0].sortable != true">
                      {{ $t(columns[0].name) }}
                    </span>
                    <span v-else class="d-flex align-items-center">
                      <div
                        v-if="['custDeviceName', 'name'].includes(columns[0].name)"
                        :class="{ checked: allOnPageSelected() }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortItemsBy(columns[0].sortBy)">
                        {{ $t(columns[0].name) }}
                      </div>
                      <div v-if="sortBy == columns[0].sortBy" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td :style="{ width: columns[0].minWidth }">
                    <span>
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceId === item.deviceId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: item.deviceProtocol === 'mqtt' ? 'mqttDevice' : item.deviceProtocol === 'udp'
                              ? 'udpDevice'
                              : 'device',
                          params: {
                            id: item.deviceId.includes(':') ? item.deviceId.split(':')[1] : item.deviceId,
                            device: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span
                          :style="{
                            maxWidth: columns[0].minWidth,
                            minWidth: columns[0].minWidth
                          }"
                          style="display: block; word-wrap: break-word"
                        >
                          <span v-if="item.deviceProtocol === 'udp'">
                            {{ item.name }}
                          </span>
                          <span v-else>
                            {{ item.custDeviceName }}
                          </span>
                        </span>
                      </RouterLink>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_index) in allDevices" :key="item_index">
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == item.deviceId
                      }"
                      class="kebab"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon mr-0" @click="openKebab(item)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>
                        <div
                          v-if="openedDevice.deviceId == item.deviceId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleEditDeviceModal('editDevice')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                              </div>
                              {{ $t("upravitZarizeni") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleChangeServiceModal('changeService')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-zmenitsluzbu.svg" />
                              </div>
                              {{ $t("zmenitSluzbu") }}
                            </div>
                            <div
                              v-if="openedDevice.partnerId === 3"
                              cols="6"
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleSendMessageModal('sendMessage')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-zprava.svg" />
                              </div>
                              {{ $t("poslatZpravuNaZarizeni") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleRemoveDeviceFromGroup([item])
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                              </div>
                              {{ $t("odebratZarizeniOdSkupiny") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else-if="!loadingData" class="my-5">
        {{ $t("zadnaZarizeniGroup") }}
      </div>
      <div v-else class="my-5">
        <AppLoader />
      </div>

      <div v-if="allDevices.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
        <div class="custom-table__footer__actions align-items-center">
          <p v-if="!toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
            <span>{{ $t("rozbalitVsechnyRadky") }}</span>
          </p>
          <p v-if="toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
            <span>{{ $t("sbalitVsechnyRadky") }}</span>
          </p>
        </div>
        <Paging
          :page="{
            currentPage: page,
            rowsPerPage: rowsPerPage,
            itemsTotalCount: allDevicesCount,
            itemsCount: allDevices.length
          }"
          @next-page="page++"
          @page="page = $event"
          @prev-page="page--"
          @reload-items="reloadItems()"
          @rows-per-page="rowsPerPage = $event"
        />
      </div>
    </div>
    <RemoveDeviceFromGroupModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteDevice"
      :text="deleteText"
      @close="toggleRemoveDeviceFromGroup()"
      @yes="
        () => {
          removeDeviceFromGroup()
          toggleRemoveDeviceFromGroup()
          reloadItems()
        }
      "
    />
    <AddToGroupsModal
      :devices="actionItems"
      :opened="openedAddToGroups"
      @close-box="toggleAddToGroupsModal"
      @open-box="toggleAddToGroupsModal"
      @reload-items="reloadItems"
    />
    <SendMessage
      :devices="actionItems"
      :opened="openedSendMessage"
      @close-box="toggleSendMessageModal"
      @open-box="toggleSendMessageModal"
      @reload-items="reloadItems"
    />
    <AddTags
      :devices="actionItems"
      :opened="openedAddTags"
      :tags="tags"
      @close-box="toggleAddTagsModal"
      @open-box="toggleAddTagsModal"
    />
    <RemoveTags
      :devices="actionItems"
      :opened="openedRemoveTags"
      :tags="tags"
      @close-box="toggleRemoveTagsModal"
      @open-box="toggleRemoveTagsModal"
    />
    <ChangeStatusModal
      :devices="actionItems"
      :opened="openedChangeStatusModal"
      @close-box="toggleChangeStatusModal"
      @open-box="toggleChangeStatusModal"
    />
    <ChangeServiceModal
      :device="actionItems[0]"
      :opened="openedChangeServiceModal"
      @close-box="toggleChangeServiceModal"
      @open-box="toggleChangeServiceModal"
    />
    <ShowMessage
      :device="deviceToShow"
      :item="messageToShow"
      :opened="openedMessageDetail"
      @close-box="toggleShowMessage"
    />
    <EditDeviceModal
      v-if="openedEditDevice.length > 0"
      :device="actionItems[0]"
      :opened="openedEditDevice"
      :tags="tags"
      @close-box="toggleEditDeviceModal"
      @open-box="toggleEditDeviceModal"
      @update-items="updateDevices"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import Paging from "@/components/paging/paging.vue"
import RemoveDeviceFromGroupModal from "@/components/confirmations/remove.vue"
import AddToGroupsModal from "@/components/modals/devices/addToGroups.vue"
import SendMessageModal from "@/components/modals/devices/sendMessage.vue"
import AddTagsModal from "@/components/modals/devices/addTags.vue"
import RemoveTagsModal from "@/components/modals/devices/removeTags.vue"
import EditDeviceModal from "@/components/modals/devices/edit.vue"
import ChangeStatusModal from "@/components/modals/devices/changeStatus.vue"
import ChangeServiceModal from "@/components/modals/devices/changeService.vue"
import ShowMessage from "@/components/modals/devices/messageShow.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Notify from "@/components/notify/notify.vue"
import Loader from "@/components/loader.vue"
import SignalStrengthIcon from "@/components/boxes/signalStrengthIcon.vue"
import BatteryStatus from "@/components/boxes/batteryStatus.vue"
import { exportDevices } from "@/plugins/exportDevices"
import TagBubbles from "../devices/tagBubbles.vue"
import {useAuthStore} from "@/store/modules/auth";
import {useConfigStore} from "@/store/modules/config";
import {useProjectStore} from "@/store/modules/project";
import { useLoraStore } from "@/store/modules/devices/lora"
import { useCommonDevicesStore } from "@/store/modules/devices/common"

export default {
  directives: {},
  components: {
    Paging,
    SignalStrengthIcon,
    BatteryStatus,
    RemoveDeviceFromGroupModal,
    EditDeviceModal,
    AddToGroupsModal,
    AddTags: AddTagsModal,
    RemoveTags: RemoveTagsModal,
    ChangeStatusModal,
    ChangeServiceModal,
    ShowMessage,
    SendMessage: SendMessageModal,
    ErrorModal,
    CopyNotification: Notify,
    AppLoader: Loader,
    TagBubbles
  },
  props: {
    group: Object,
    selectable: Boolean
  },
  setup() {
    const projectStore = useProjectStore()
    const loraStore = useLoraStore()
    const commonDevicesStore = useCommonDevicesStore()

    return { projectStore, loraStore, commonDevicesStore }
  },
  data() {
    return {
      tableWidth: 0,
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      search: "",
      suggested: "",
      suggestionsArray: [],
      isActionsDropdownVisible: false,
      sort: "custDeviceName",
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      openedSideBox: false,
      openedDevice: {},
      openedGroups: [],
      openedTags: [],
      toggledAllRows: false,
      copyConfirmVisible: false,
      openedDeleteDevice: false,
      openedAddToGroups: [],
      openedRemoveFromGroups: [],
      openedChangeStatusModal: [],
      openedChangeServiceModal: [],
      deleteText: "",
      openedMessageDetail: [],
      deviceToShow: {},
      messageToShow: {},
      tags: [],
      openedAddTags: [],
      openedRemoveTags: [],
      openedSendMessage: [],
      openedEditDevice: [],
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      sortBy: "custDeviceName",
      sortType: "asc",
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      loadingData: true,
      deviceFilter: [],
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    },
    allDevices() {
      return this.commonDevicesStore.deviceCommonList
    },
    allDevicesCount() {
      return this.commonDevicesStore.deviceCommonListCount
    },
    itemsCount() {
      return this.loraStore.totalCount
    },
    columns() {
      if (this.group.tags?.includes("hidden_MQTT")) {
        return [
          {
            type: "custDeviceName",
            name: "custDeviceName",
            sortable: true,
            sortBy: "custDeviceName",
            visible: true,
            minWidth: "250px",
            order: 1
          },
          {
            type: "status",
            name: "status",
            sortable: true,
            sortBy: "status",
            visible: true,
            minWidth: "100px",
            order: 2
          },
          {
            type: "deviceId",
            name: "idZarizeniMQTT",
            sortable: true,
            sortBy: "deviceId",
            visible: true,
            minWidth: "120px",
            order: 3
          },
          {
            type: "deviceGroups",
            name: "deviceGroups",
            sortable: false,
            visible: true,
            minWidth: "300px",
            order: 4
          },
          {
            type: "tags",
            name: "tags",
            sortable: false,
            visible: true,
            minWidth: "100px",
            order: 5
          },
          {
            type: "topicIn",
            name: "topicIn",
            sortable: false,
            visible: true,
            minWidth: "300px",
            order: 6
          },
          {
            type: "lastMessageIn",
            name: "lastMessageIn",
            sortable: true,
            sortBy: "lastMessageIn",
            visible: true,
            minWidth: "150px",
            order: 7
          },
          {
            type: "custServiceId",
            name: "custServiceId",
            sortable: false,
            visible: false,
            minWidth: "210px",
            order: 8
          },
          {
            type: "transformationLabel",
            name: "transformationLabel",
            sortable: false,
            visible: false,
            minWidth: "210px",
            order: 9
          },
          {
            type: "provisionTime",
            name: "PROVISION_TIME_LABEL",
            sortable: false,
            visible: false,
            minWidth: "210px",
            order: 10
          },
          {
            type: "preregistrationEnd",
            name: "PREREGISTRATION_END_LABEL",
            sortable: false,
            visible: false,
            minWidth: "210px",
            order: 11
          },
          {
            type: "preregistrationMsgsLeft",
            name: "PREREGISTRATION_MSG_LEFT_LABEL",
            sortable: false,
            visible: false,
            minWidth: "200px",
            order: 12
          }
        ]
      } else if (this.group.tags?.includes("hidden_UDP")) {
        return [
          {
            type: "name",
            name: "custDeviceName",
            sortable: true,
            sortBy: "name",
            visible: true,
            minWidth: "300px",
            order: 1
          },
          {
            name: "status",
            type: "status",
            sortable: true,
            sortBy: "status",
            visible: true,
            minWidth: "80px",
            order: 2
          },
          {
            type: "deviceId",
            name: "idZarizeniMQTT",
            sortable: true,
            sortBy: "deviceId",
            visible: true,
            minWidth: "150px",
            order: 3
          },
          {
            name: "deviceGroups",
            type: "deviceGroups",
            sortable: false,
            visible: true,
            minWidth: "250px",
            order: 4
          },
          {
            name: "tags",
            type: "tags",
            sortable: false,
            visible: true,
            minWidth: "250px",
            order: 5
          },
          {
            name: "lastMessageIn",
            type: "lastMessageIn",
            sortable: true,
            sortBy: "lastMessageIn",
            visible: true,
            minWidth: "250px",
            order: 6
          }
        ]
      }

      return [
        {
          type: "custDeviceName",
          name: "custDeviceName",
          sortable: true,
          sortBy: "custDeviceName",
          visible: true,
          minWidth: "200px",
          order: 1
        },
        {
          type: "deviceId",
          name: "deviceId",
          sortable: true,
          sortBy: "deviceId",
          visible: true,
          minWidth: "120px",
          order: 2
        },
        {
          type: "deviceGroups",
          name: "deviceGroups",
          sortable: false,
          visible: true,
          minWidth: "300px",
          order: 3
        },
        {
          type: "status",
          name: "status",
          sortable: true,
          sortBy: "suspended",
          visible: true,
          minWidth: "100px",
          order: 4
        },
        {
          type: "tags",
          name: "tags",
          sortable: false,
          visible: true,
          minWidth: "100px",
          order: 5
        },
        {
          type: "bateryStatus",
          name: "bateryStatus",
          sortable: true,
          sortBy: "bateryStatus",
          visible: true,
          minWidth: "100px",
          order: 6
        },
        {
          type: "signalStrength",
          name: "signalStrength",
          sortable: true,
          sortBy: "signalStrength",
          visible: true,
          minWidth: "80px",
          order: 7
        },
        {
          type: "lastMessageIn",
          name: "lastMessageIn",
          sortable: true,
          sortBy: "lastMessageIn",
          visible: true,
          minWidth: "150px",
          order: 8
        },
        {
          type: "deviceType",
          name: "devicetype",
          sortable: true,
          sortBy: "devicetype",
          visible: true,
          minWidth: "100px",
          order: 9
        }
      ]
    }
  },
  watch: {
    group() {
      this.selectedRows = []
      this.loadDevices()
    },
    search() {
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    suggested() {},
    project() {
      this.selectedRows = []
      this.loadDevices()
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedDevices = this.allDevices.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      )
      let selectedDevicesId = selectedDevices.map((d) => d.deviceId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allDevicesId = selectedAllRowsArray.map((d) => d.deviceId)
      this.isSelectedAllOnPage = selectedDevicesId.every((ai) => allDevicesId.includes(ai)) ? true : false
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    if (localStorage.rowsPerPage) {
      this.rowsPerPage = localStorage.rowsPerPage
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }

    if (this.project && this.group.deviceGroupId) {
      this.loadDevices()
    }

    this.updateResponsiveTable()
  },
  methods: {
    getTopicIn(deviceId) {
      return this.customerId + "." + this.projectId + ".in." + deviceId
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "lora")
    },
    async loadDevices() {
      /** find all devices with defined filter */
      let devices = await this.commonDevicesStore.getDeviceCommonList({
        filters: {
          projectId: this.projectId,
          deviceGroupId: this.group.deviceGroupId
        },
        search: this.search,
        sort: this.sort,
        sortType: this.sortType,
        rowsPerPage: this.rowsPerPage,
        currentPage: this.page
      })

      if (devices) {
        this.loadingData = false
        console.log("loadDevice loadingData" + this.loadingData)
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    reloadItems() {
      this.selectedRows = []
      this.loadDevices()
      this.$parent.loadGroup()
    },
    searchLoraDevices() {
      this.page = 0
      this.suggestionsArray = []
      this.reloadItems()
    },
    suggestions() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/lora/devices/suggestions?projectId[eq]=" +
            this.project.projectId +
            "&groupdId[eq]=" +
            this.group.deviceGroupId +
            "&search=" +
            this.search +
            "*",
          {}
        )
        .then((response) => {
          this.suggestionsArray = response.data.data
        })
        .catch(() => {})
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchLoraDevices()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.search = ""
      this.suggested = ""
      this.searchLoraDevices()
      this.suggestionsArray = []
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = !this.isActionsDropdownVisible
    },
    sortItemsBy(sortBy) {
      this.sortBy = sortBy
      if (this.sortType == "asc") {
        this.sortType = "desc"
      } else {
        this.sortType = "asc"
      }
      this.sort = new String(sortBy)
      this.reloadItems()
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = this.openedRowsSelect ? false : true
    },
    addToSelected(device) {
      if (this.selectedRows.filter((e) => e.deviceId === device.deviceId).length > 0) {
        //let obj = this.selectedRows.filter(e => e.deviceId === device.deviceId);

        const index = this.selectedRows.map((e) => e.deviceId).indexOf(device.deviceId)

        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(device)
      }
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedDevices = this.allDevices

      let selectedDevicesId = selectedDevices.map((d) => d.deviceId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allEndpointsId = selectedAllRowsArray.map((d) => d.deviceId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.allDevices)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedDevicesId.every((ai) => allEndpointsId.includes(ai))) {
          let indexes = []
          selectedDevices.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })
          this.selectedRows.splice(indexes[0], indexes.length)
        } else {
          let indexes = []
          let same = []
          this.selectedRows.forEach((selected) => {
            let filteredArray = selectedDevices.filter((e) => e.deviceId === selected.deviceId)
            same.push(filteredArray[0])
          })
          same.forEach((element) => {
            if (element != undefined) {
              indexes.push(this.selectedRows.findIndex((obj) => obj.deviceId == element.deviceId))
            }
          })
          for (var i = indexes.length - 1; i >= 0; i--) {
            this.selectedRows.splice(indexes[i], 1)
          }

          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedDevices)
              : [].concat.apply([], selectedDevices)
        }
      }
    },
    allOnPageSelected() {
      if (this.allDevices.length == this.selectedRows.length) {
        return true
      } else {
        return false
      }
    },
    openKebab(device) {
      this.openedDevice = this.openedDevice == device ? {} : device
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    toggleSideBox(box) {
      this.openedSideBox = box == false ? false : box
    },
    toggleGroup(device) {
      console.log("devicesTable.vue toggleGroup()")
      var index = this.openedGroups.indexOf(device)
      if (this.openedGroups.indexOf(device) > -1) {
        this.openedGroups.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedGroups.push(device)
      }
    },
    toggleTag(device) {
      var index = this.openedTags.indexOf(device)
      if (this.openedTags.indexOf(device) > -1) {
        this.openedTags.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedTags.push(device)
      }
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedTags = []
        this.openedGroups = []
        this.toggledAllRows = false
      } else {
        this.openedTags = [].concat.apply([], this.allDevices)
        this.openedGroups = [].concat.apply([], this.allDevices)
        this.toggledAllRows = true
      }
    },
    toggleRemoveDeviceFromGroup(items) {
      console.log("devicesTable.vue toggleRemoveDeviceFromGroup()")
      console.log(this.group)
      console.log("after group")
      if (this.openedDeleteDevice == true) {
        this.openedDeleteDevice = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "zarizeniPocet" : items[0].custDeviceName
        }
        this.openedDeleteDevice = true
      }
    },
    removeDeviceFromGroup() {
      console.log("devicesTable removeDeviceFromGroup()")
      this.errorsToTranslate = []
      let promises = []
      let notifications = []

      this.actionItems.forEach((item) => {
        let id = item.deviceId
        promises.push(
          axios
            .delete(
              process.env.VUE_APP_API +
                "/device-groups/" +
                this.group.deviceGroupId +
                "/devices/lora/" +
                id +
                "/assign",
              {}
            )
            .then((response) => {
              if (response.status == 204) {
                this.allDevices.splice(this.allDevices.indexOf(item), 1)
                this.group.devices--
                notifications.push({
                  text: "notificationDeviceGroupRemove",
                  error: false,
                  params: {
                    deviceId: item.deviceId,
                    custDeviceName: item.custDeviceName,
                    deviceGroupId: this.group.deviceGroupId,
                    deviceGroupName: this.group.deviceGroupName
                  }
                })
              }
            })
            .catch((error) => {
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  deviceId: item.deviceId,
                  custDeviceName: item.custDeviceName
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })
      Promise.all(promises).then(() => {
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.openedError = true
      })
    },
    toggleAddToGroupsModal(box) {
      console.log("devicesTable.vue toggleAddToGroupModal()")
      if (this.openedAddToGroups.indexOf(box) > -1) {
        box == undefined
          ? (this.openedAddToGroups = [])
          : this.openedAddToGroups.splice(this.openedAddToGroups.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddToGroups.push(box)
      }
    },
    toggleSendMessageModal(box) {
      console.log("devicesTable.vue toggleSendMessageModal()")
      if (box == undefined || this.openedSendMessage.indexOf(box) > -1) {
        box == undefined
          ? (this.openedSendMessage = [])
          : this.openedSendMessage.splice(this.openedSendMessage.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedSendMessage.push(box)
      }
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditDevice = [])
          : this.openedEditDevice.splice(this.openedEditDevice.indexOf(box), 1)

        this.selectedRows = []
        this.selectedAll = false
        if (box == undefined || box == "editDevice") {
          this.openedDevice = {}
        }
      } else {
        this.openedEditDevice.push(box)
      }
    },
    toggleAddTagsModal(box) {
      if (box == undefined || this.openedAddTags.indexOf(box) > -1) {
        box == undefined ? (this.openedAddTags = []) : this.openedAddTags.splice(this.openedAddTags.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddTags.push(box)
      }
    },
    toggleRemoveTagsModal(box) {
      if (box == undefined || this.openedRemoveTags.indexOf(box) > -1) {
        box == undefined
          ? (this.openedRemoveTags = [])
          : this.openedRemoveTags.splice(this.openedRemoveTags.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveTags.push(box)
      }
    },
    toggleChangeStatusModal(box) {
      if (box == undefined || this.openedChangeStatusModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedChangeStatusModal = [])
          : this.openedChangeStatusModal.splice(this.openedChangeStatusModal.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedChangeStatusModal.push(box)
      }
    },
    toggleChangeServiceModal(box) {
      if (box == undefined || this.openedChangeServiceModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedChangeServiceModal = [])
          : this.openedChangeServiceModal.splice(this.openedChangeServiceModal.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedChangeServiceModal.push(box)
      }
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : this.openedMessageDetail.splice(this.openedMessageDetail.indexOf(box), 1)
      } else {
        this.openedMessageDetail.push(box)
      }
    },
    setMessageDeviceToShow(device) {
      axios
        .get(
          process.env.VUE_APP_API +
            "/lora/devices/" +
            device.deviceId +
            "/up/messages?from=" +
            device.lastMessageIn +
            "&to=" +
            device.lastMessageIn +
            "&limit=1000",
          {}
        )
        .then((result) => {
          const length = result.data.data.length
          let message = result.data.data[length - 1]
          message.type = "up"
          let gws = message.message.gws
          if (gws != null) {
            let sortedBySnr = _.orderBy(gws, "snr", "desc")
            let largestSnr = sortedBySnr[0].snr
            message.snr = largestSnr
            let sortedByRssi = _.orderBy(gws, "rssi", "desc")
            let largestRssi = sortedByRssi[0].rssi
            message.rssi = largestRssi
          }

          this.messageToShow = message
          this.deviceToShow = device
        })
        .catch(() => {})
    },
    updateDevices(devices) {
      console.log("devicesTable.vue updateDevices()")
      devices.forEach((device) => {
        let objIndex = this.allDevices.findIndex((obj) => obj.deviceId == device.deviceId)
        this.allDevices[objIndex] = device

        this.openedTags.push(device)
        this.openedGroups.push(device)
      })
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    closeKebab() {
      this.openedDevice = {}
    },
    middleware(event) {
      return event.target.className !== "kebab"
    },
    getTableColumns() {
      // must be here because updateResponsiveTable expects it, but it is not used here
      return {}
    },
    async exportDevices(type) {
      this.errorsToTranslate = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))
      const loraDevices = this.selectedRows.filter((d) => d.deviceProtocol === "lora").map((d) => d.deviceId)
      const mqttDevices = this.selectedRows.filter((d) => d.deviceProtocol === "mqtt").map((d) => d.deviceId)
      const udpDevices = this.selectedRows.filter((d) => d.deviceProtocol === "udp").map((d) => d.deviceId)
      let errors = []
      if (loraDevices.length) {
        errors = errors.concat(await exportDevices(type, "lora", this.projectId, loraDevices))
      }
      if (mqttDevices.length) {
        errors = errors.concat(await exportDevices(type, "mqtt", this.projectId, mqttDevices))
      }
      if (udpDevices.length) {
        errors = errors.concat(await exportDevices(type, "udp", this.projectId, udpDevices))
      }
      this.$store.commit("modals/setWaitingLoader", "")
      errors = errors.filter((e) => !!e)
      if (errors.length) {
        this.errorsToTranslate = errors
        this.openedError = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.eui-short {
  display: none;
}

.eui-full {
  display: block;
}

/*
.shadowed .eui-short {
  display: block;
}

.shadowed .eui-full {
  display: none;
}
*/
</style>
